/* eslint-disable prefer-destructuring */
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { I18n } from '@corporate/ng-tebis-base-components';
import { MDIRouteActivation } from '../../../05_layout/feature-instance/feature-instance.component';
import { TabService } from '../../../05_layout/flat-layout/flat-tabs/tab.service';
import { NavbarComponent } from '../../navbars/navbar/navbar.component';
import { NavbarButtonComponent } from '../../navbars/navbar-button/navbar-button.component';
import { ProcessNavigationComponent } from "../../../02_ui/process-navigation/process-navigation.component";
import { ArticleNavbarService } from './article-navbar.service';

@Component({
  selector: 'tps-article-navbar',
  imports: [
    MatIconModule,
    NavbarComponent,
    NavbarButtonComponent,
    ProcessNavigationComponent
],
  templateUrl: './article-navbar.component.html',
  styleUrl: './article-navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleNavbarComponent {

  i18n = inject(I18n);

  tabService = inject(TabService);
  routeActivation = inject(MDIRouteActivation);
  route = input<string|undefined>();

  articleID = input<string>('');

  state = inject(ArticleNavbarService);

  constructor() {
    effect(() => this.state.articleId.set(this.articleID()));
  }

  selected = computed(() => this.tabService.getCurrentPath() || this.route() || '');

  parentTab = computed(() => {
    let parent = this.tabService.getCurrentTab();
    const parentPath = `article/${this.articleID()}`;
    if (parent.parent && parent.path !== parentPath) {
      parent = parent.parent;
    }
    return parent;
  });
}
